import React from "react";
import { HelpIndicator, Text } from "@jsq/ds/core";
import { FormTextInput } from "@jsq/ds/forms";
import { Icon } from "@jsq/ds/icons";
import { LocalRoutingInputFields, localRoutingFieldsForCountry } from "../schema";

type LocalRoutingFieldDescriptor = {
  label: string;
  helpText: string;
  placeholder: string;
};

export const LOCAL_ROUTING_FIELD_DESCRIPTORS: Readonly<
  Record<LocalRoutingInputFields, LocalRoutingFieldDescriptor>
> = {
  [LocalRoutingInputFields.SortCode]: {
    label: "Sort code",
    helpText:
      "A sort code is a 6-digit number that identifies your bank and branch, usually formatted as XX-XX-XX.",
    placeholder: "e.g. 20-00-00",
  },
  [LocalRoutingInputFields.TransitNumber]: {
    label: "Transit number",
    helpText:
      "A 5-digit number that identifies your specific bank branch. It can be found on your bank statement or cheque.",
    placeholder: "5 digits",
  },
  [LocalRoutingInputFields.InstitutionNumber]: {
    label: "Institution number",
    helpText:
      "A 3-digit code that identifies your financial institution. It can be found on your bank statement or cheque.",
    placeholder: "3 digits",
  },
  [LocalRoutingInputFields.Bsb]: {
    label: "BSB code",
    helpText:
      "A BSB (Bank State Branch) code is a 6-digit number that identifies your bank and branch in Australia, often formatted as XXX-XXX.",
    placeholder: "e.g. 083-004",
  },
};

type LocalRoutingFieldsProps = {
  country?: string;
  usAccount?: boolean;
};

export const LocalRoutingFields: React.FC<LocalRoutingFieldsProps> = ({
  country,
  usAccount,
}) => (
  <>
    {localRoutingFieldsForCountry(country, usAccount).map((name) => {
      const { label, helpText, placeholder } = LOCAL_ROUTING_FIELD_DESCRIPTORS[name];

      return (
        <FormTextInput
          key={name}
          isFullWidth
          name={name}
          placeholder={placeholder}
          label={
            <HelpIndicator id={`${name}-help-indicator`} placement="right" content={helpText}>
              <Text>
                {label} <Icon type="question-circle" size="small" variant="outline" />
              </Text>
            </HelpIndicator>
          }
        />
      );
    })}
  </>
);
